import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppHelper } from 'src/app/helpers/app.helper';
import { DialogContent } from 'src/app/models/dialogContent';


@Component({
  selector: 'app-dialog-body',
  templateUrl: './dialog-body.component.html',
  styleUrls: ['./dialog-body.component.scss']
})
export class DialogBodyComponent implements OnInit {
  bodyUniqueID: string

  constructor(public dialogRef: MatDialogRef<DialogBodyComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogContent) {
    this.bodyUniqueID =  AppHelper.newUUID;
  }

  ngOnInit(): void {
    setTimeout(() => {
      const bodyEle = document.getElementById(`dialog-body-${this.bodyUniqueID}`);
      bodyEle && (bodyEle.innerHTML = this.data.htmlBody);
    }, 300);
  }

  close(returnValue: any) {
    this.dialogRef.close(returnValue);
  }
}
